// extracted by mini-css-extract-plugin
module.exports = {"small-btn":"resize-image-download-component-module__rnMBmG__small-btn"};